import React from 'react'
import styled from 'styled-components'
import IconGithubWhite from 'assets/icons/github-white.svg'
import Clickable from 'components/Clickable'

// TODO: to replace with the Button components intended for the landing page
const StyledButton = styled(Clickable)`
	display: inline-flex;
	align-items: center;

	border: none;
	padding: 8px 12px;
	background: var(--color-darkGrey);
	border-radius: 4px;
	user-select: none;

	& > * + * {
		margin-left: 8px;
	}

	&:hover {
		text-decoration: none !important; /* Sorry for the important... */
		color: white;
		opacity: 0.8;
	}

	& span {
		color: white;
	}
`

const CloneButton = ({ to }) => {
	return (
		<StyledButton to={to}>
			<img src={IconGithubWhite} />
			<span>Clone Project</span>
		</StyledButton>
	)
}

export default CloneButton
